/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/*
 * File: CompanySelect.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 01 Dec 2021 1:52:14 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Select } from 'antd';
import Cookies from 'js-cookie';
import { CompanyModel } from 'models/CompanyModel';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useGetLegalEntitiesQuery } from 'redux/services/maggieCadabby/useMaggieCadabbyService';
import { setSelectedCompanyDataAreaId, setSelectedLegalEntity } from 'redux/slices/appSlice';
import { setCustomerSelectionOffset } from 'redux/slices/customerSelectionFiltersSlice';
import { ReduxState } from 'redux/store';

export const CompanySelect = (): JSX.Element => {
  const { selectedCompanyDataAreaId } = useSelector((state: ReduxState) => state.app);
  const { acuityContext } = useSelector((state: ReduxState) => state.app);

  const [selectedCompany, _setSelectedCompany] = useState<string | undefined>(undefined);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { data, isLoading, isFetching } = useGetLegalEntitiesQuery(undefined);

  const handleSave = (company: CompanyModel): void => {
    dispatch(setSelectedLegalEntity(company));
  };

  const handleSelect = (value: string): void => {
    dispatch(setCustomerSelectionOffset(0));
    _setSelectedCompany(value);
    dispatch(setSelectedCompanyDataAreaId(value));
    if (process.env.REACT_APP_COOKIE_PREFIX === 'localdev') {
      Cookies.set(`legalEntity`, value, { expires: 365 });
    } else {
      Cookies.set(`legalEntity`, value, { expires: 365, domain: 'mdsiinc.com' });
    }
    navigate('/internal');
  };

  const optionsJSX = data?.data.map((company) => (
    <Select.Option key={company.id} value={company.dataAreaId}>
      <div onClick={(): void => handleSave(company)}>{company.dataAreaId}</div>
    </Select.Option>
  ));

  useEffect(() => {
    if (selectedCompanyDataAreaId) {
      dispatch(setSelectedLegalEntity(data?.data.find((entity) => entity.dataAreaId.toLocaleLowerCase() === selectedCompanyDataAreaId.toLocaleLowerCase())));
    } else {
      dispatch(setSelectedLegalEntity(data?.data.find((entity) => entity.dataAreaId.toLocaleLowerCase() === 'mdsi')));
    }
  }, [acuityContext, data, selectedCompany, selectedCompanyDataAreaId]);

  return (
    <Select
      style={{ width: 90 }}
      onSelect={handleSelect}
      placeholder="Company"
      loading={isLoading || isFetching}
      defaultValue={selectedCompanyDataAreaId ?? undefined}
      value={selectedCompanyDataAreaId ?? undefined}>
      {optionsJSX}
    </Select>
  );
};
